// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"546cc557","516":"8806cbbf","723":"86cc1e49","810":"cfe0d609"}[chunkId] + ".chunk.js";
};